import types from "./actionTypes";
import * as selectors from "./selectors";
import { findRelativePosition } from "../../../services/reactFlowService";
import { dealWithTemplateClusterlet } from '../../undoredo/actions';
import { getTemplateClusterlets } from '../../constructs/templated_clusterlet/selectors'
import { deleteClusterletConnection, addClusterletConnection } from "../../constructs/clusterlet_connections/actions";
import { convertToArray } from "../../../services/blueprint";
import { createSensor } from "../../../services/entities/sensor";
import { addClusterlet } from "../../constructs/clusterlets/actions";
import { createDelegate } from "../../../services/entities/delegate";
import { createConnection } from "../../../services/entities/connections";
import { toInstanceData } from "../../../services/reactFlowService";
import { addInstance } from "../../../store/constructs/bootloaders/actions";
import { getNetworks, networkForDelegate } from "../../../store/constructs/networks/selectors";
import { getClusterlets, getConstructs } from "../../../store/constructs/clusterlets/selectors";
import { addNetwork } from "../../../store/constructs/networks/actions";




export const addTemplatedClusterlet = (payload, noUndoRedo) => (dispatch, getState) => {

    const templates = getTemplateClusterlets(getState());

    if (payload.absolutePosition) {
        delete payload.absolutePosition
    }

    if (noUndoRedo != true) dispatch(dealWithTemplateClusterlet(payload, 'add'));

    dispatch({
        type: types.ADD_TEMPLATED_CLUSERLET,
        payload,
    })
}

export const editTemplate = (payload, noUndoRedo, associates) => (dispatch) => {


    console.log('payload---edit-->', payload)

    if (payload.absolutePosition) {
        delete payload.absolutePosition
    }

    if (noUndoRedo != true) dispatch(dealWithTemplateClusterlet(payload, 'edit'))




    dispatch({
        type: types.EDIT_TEMPLATE,
        payload,
    })
}


export const onDragStopTemplate = (data) => (dispatch, getState) => {
    const template = data.id

    const elements = selectors.getTemplateClusterlets(getState());
    // console.log("elements", elements)	

    const index = elements.findIndex(e => e.id === template)
    // console.log("index", index)

    const type = elements[index].type;

    const relativePosition = findRelativePosition(data.position, type);
    data.position = relativePosition;

    const editedElement = {
        ...elements[index],
        position: { ...elements[index].position, ...data.position }
    }
    // console.log("edited element", editedElement)

    const payload = editedElement

    dispatch(editTemplate(payload));
};


export const updateFullTemplate = (templates) => ({
    type: types.UPDATE_FULL_TEMPLATE,
    payload: templates
})


export const deleteTemplate = (template, noUndoRedo) => (dispatch, getState) => {

    // if (noUndoRedo != true) dispatch(dealWithTemplateClusterlet(template, 'delete'))

    dispatch({
        type: types.DELETE_TEMPLATE,
        payload: template
    })

}


export const deleteTemplateAndAssociates = (payload) => async (dispatch, getState) => {

    const { item, connections } = await selectors.getDeletedTemplateAssociates({ item: payload, state: selectors.getConstructs(getState()) })

    await dispatch(deleteTemplate(item, true))

    await connections?.forEach(async edge => {
        await dispatch(deleteClusterletConnection({ item: edge, connetedTemplate: [] }, true))
    })

    const payloadData = { item, connections }

    await dispatch(dealWithTemplateClusterlet(payloadData, "delete"))

}

/** 
 * Add templated clusterlet to store 
 * Find out if any other nodes have to imported as a part of template
 * */
export const addTemplateToApp = (template) => async (dispatch, getState) => {

    const clusterlets = convertToArray(template?.metajson?.clusterlets);
    const templateSensors = [];
    const templateDelegates = [];

    /** Does template have sensors */
    clusterlets.forEach(c => {
        if (c?.args?.type == 'sensor') {
            templateSensors.push(c);
        }
    });

    /** Does template have delegates */
    clusterlets.forEach(d => {
        if (d?.args?.type == 'delegate') {
            templateDelegates.push(d);
        }
    })



    /** Setting template dependencies */
    const undoDependencyForTemplate = [];

    if (templateSensors.length > 0) {
        undoDependencyForTemplate.push({ sensors: templateSensors });
    }

    if (templateDelegates.length > 0) {
        undoDependencyForTemplate.push({ delegates: templateDelegates });
    }

    dispatch(addTemplatedClusterlet(template, undoDependencyForTemplate));

    let sensor = null;
    let delegate = null;

    /** Adding extra sensor to store */
    if (templateSensors.length == 0) {
        sensor = createSensor(`${template.name}_sensor`, `${template.name} sensor`);
        dispatch(addClusterlet(sensor, true));
    }

    /** Adding extra delegate to store */
    if (templateDelegates.length == 0) {

        /* Create a delegate structure */
        delegate = createDelegate(`${template.name}_GW`, `${template.name} Gateway`);


        /* Add instance details */
        const clusterletDetails = { ...delegate }
        const instanceData = toInstanceData(clusterletDetails);
        console.log({ instanceData });
        dispatch(addInstance(instanceData, true));

        /* Add network*/
        const constructs = getConstructs(getState());
        console.log({ constructs }, 'CONSTRUCTSS')
        const { networkExists, network: networkObj } = networkForDelegate({ editedDelegate: clusterletDetails, constructs });
        if (!networkExists) dispatch(addNetwork(networkObj, true));

        /* Finally save delegate*/
        delegate.attributes.network = networkObj.id
        dispatch(addClusterlet(delegate, true));

    }

    if (sensor !== null && delegate !== null) {
        const connection = createConnection(sensor, delegate, 'right', 'left');
        dispatch(addClusterletConnection(connection, false, template));
    }


}

export const resetTemplate = (templates) => ({
    type: types.RESET_TEMPLATE,
    payload: templates
})
